"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonTranscodable = exports.isMetadataFile = exports.safeGetNameTypeAndExt = exports.getNameTypeAndExt = exports.getClipTypeFromExt = exports.isDocument = exports.isPdf = exports.isAnimatedType = exports.isVideoType = exports.isPhotoType = exports.getName = exports.getExt = exports.PdfExts = exports.DocumentExtensions = exports.VideoExts = exports.AnimatedExts = exports.PhotoExts = exports.RawPhotoExts = exports.FALLBACK_NAME = exports.FALLBACK_EXT = void 0;
const types_1 = require("@air/types");
const path_1 = require("path");
const AudioExts = ['wav', 'm4a', 'mp3', 'aiff', 'aif'];
exports.FALLBACK_EXT = 'file';
exports.FALLBACK_NAME = '_untitled';
exports.RawPhotoExts = [
    '3fr',
    'ari',
    'arw',
    'bay',
    'crw',
    'cr2',
    'cr3',
    'cap',
    'data',
    'dcs',
    'dcr',
    'dng',
    'drf',
    'eip',
    'erf',
    'fff',
    'gpr',
    'iiq',
    'k25',
    'kdc',
    'mdc',
    'mef',
    'mos',
    'mrw',
    'nef',
    'nrw',
    'obm',
    'orf',
    'pef',
    'ptx',
    'pxn',
    'r3d',
    'raf',
    'raw',
    'rwl',
    'rw2',
    'rwz',
    'sr2',
    'srf',
    'srw',
    'tif',
    'tiff',
    'x3f',
];
exports.PhotoExts = [
    'jpg',
    'png',
    'heic',
    'jpeg',
    'svg',
    'psd',
    'psb',
    'webp',
    'jfif',
    'avif',
    'ai',
    'eps',
];
exports.AnimatedExts = ['gif'];
exports.VideoExts = [
    'avi',
    'flv',
    'm2v',
    'm4p',
    'm4v',
    'mkv',
    'mov',
    'mp2',
    'mp4',
    'mpeg',
    'mpg',
    'mxf',
    'mts',
    'webm',
    'wmv',
    'r3d',
    'mpegts',
    'asf',
    'ts',
    'm2ts',
    'qt',
];
exports.DocumentExtensions = ['doc', 'docx', 'ppt', 'pptx', 'potx', 'key'];
const nonTranscodableExts = ['eip', 'r3d', 'raw', 'dcr', 'jp2'];
exports.PdfExts = ['pdf'];
const DEFAULT_TYPE = types_1.ClipType.nonMedia;
const pathHasExt = (path) => (0, path_1.extname)(path) !== '';
const getExt = (pathOrExt) => {
    if (!pathOrExt) {
        throw new Error("Can't getExt on a falsy path");
    }
    return pathOrExt.split('.').pop();
};
exports.getExt = getExt;
const getName = (path) => {
    if (!path) {
        throw new Error("Can't getName on a falsy path");
    }
    return (0, path_1.basename)(path, (0, path_1.extname)(path));
};
exports.getName = getName;
const curryWhitelist = (whitelist) => (pathOrExt) => !!pathOrExt && whitelist.includes((0, exports.getExt)(pathOrExt).toLowerCase());
const isAudioType = curryWhitelist(AudioExts);
exports.isPhotoType = curryWhitelist([
    ...exports.RawPhotoExts,
    ...exports.PhotoExts,
    ...exports.PdfExts,
    ...exports.DocumentExtensions,
]);
exports.isVideoType = curryWhitelist(exports.VideoExts);
exports.isAnimatedType = curryWhitelist(exports.AnimatedExts);
exports.isPdf = curryWhitelist(exports.PdfExts);
exports.isDocument = curryWhitelist(exports.DocumentExtensions);
const extTypes = [
    { check: exports.isPhotoType, extType: types_1.ClipType.photo },
    { check: exports.isAnimatedType, extType: types_1.ClipType.animated },
    { check: exports.isVideoType, extType: types_1.ClipType.video },
    { check: isAudioType, extType: types_1.ClipType.audio },
];
const getClipTypeFromExt = (ext, importedName) => {
    const foundExtType = extTypes.find(({ check }) => check(ext));
    const isMetaDataFile = importedName && hasLeadingPeriod(importedName);
    return foundExtType && !isMetaDataFile ? foundExtType.extType : DEFAULT_TYPE;
};
exports.getClipTypeFromExt = getClipTypeFromExt;
const getNameTypeAndExt = (path) => {
    if (!path || !path.includes('.')) {
        throw new Error(`Invalid path for getNameTypeAndExt: ${path}`);
    }
    const importedName = (0, exports.getName)(path);
    const ext = (0, exports.getExt)(path);
    const type = (0, exports.getClipTypeFromExt)(ext, importedName);
    return { ext, type, importedName };
};
exports.getNameTypeAndExt = getNameTypeAndExt;
const safeGetNameTypeAndExt = (path) => {
    try {
        return (0, exports.getNameTypeAndExt)(path);
    }
    catch (error) {
        console.log(`Invalid path name detected pathName: ${path}; falling back to .${exports.FALLBACK_EXT} extension`);
        return {
            ext: exports.FALLBACK_EXT,
            type: types_1.ClipType.nonMedia,
            importedName: path === undefined ? exports.FALLBACK_NAME : path,
        };
    }
};
exports.safeGetNameTypeAndExt = safeGetNameTypeAndExt;
const hasLeadingPeriod = (str) => str[0] === '.';
const isMetadataFile = (str) => hasLeadingPeriod(str) || !pathHasExt(str);
exports.isMetadataFile = isMetadataFile;
const isNonTranscodable = (ext) => nonTranscodableExts.includes(ext.toLowerCase());
exports.isNonTranscodable = isNonTranscodable;
//# sourceMappingURL=path.js.map